import { Select } from "@chakra-ui/react";
import { ColorIcon, colors } from "goi_common";
import React from "react";

interface DropdownProps {
  name: string;
  value: string;
  onChange: any;
  values: Array<any>;
  disabled?: boolean;
  className?: string;
  borderRadius?: string;
  hasBorder?: boolean;
}

export function GrayDropdown({
  name,
  value,
  onChange,
  values,
  disabled,
  className,
  borderRadius,
  hasBorder = true,
}: DropdownProps) {
  return (
    <Select
      background={colors.gray50}
      color={disabled ? `${colors.gray700}80` : colors.gray700}
      // opacity={disabled ? 0.6 : 1}
      border={hasBorder ? `1px solid ${colors.gray200}` : "none"}
      className={className || "body_16_r"}
      // fontSize={14}
      height="48px"
      borderRadius={borderRadius || "6px"}
      value={value}
      onChange={onChange}
      icon={
        <ColorIcon
          name="icon-arrow-right-small-mono"
          size={16}
          color={colors.gray600}
          css={{ transform: "rotateZ(90deg)" }}
        />
      }
    >
      {values.length > 0 ? (
        <>
          <option value={""}>{name}</option>
          {values.map((res: any) => {
            return (
              <option key={res.value} value={res.value}>
                {res.key}
              </option>
            );
          })}
        </>
      ) : (
        <option value={0}>{name}</option>
      )}
    </Select>
  );
}
